import { useTranslation } from "react-i18next";
import { CalendarClock, Webhook } from "lucide-react";

import { ListFilterToolbar } from "@/shared/components/ListFilterToolbar";
import {
  EMPTY_JOBS_FILTER,
  isEmptyJobsFilter,
  type JobsFilterState,
  type JobsStatusFilter,
  type JobsTriggerFilter,
} from "../utils/filter";

interface JobsToolbarProps {
  value: JobsFilterState;
  onChange: (next: JobsFilterState) => void;
  total: number;
}

/** Busca e filtros da tela Jobs (AB#86605): status no grupo segmentado, gatilho no popover. */
export const JobsToolbar = ({ value, onChange, total }: JobsToolbarProps) => {
  const { t } = useTranslation();

  return (
    <ListFilterToolbar<JobsStatusFilter, JobsTriggerFilter>
      query={value.query}
      onQueryChange={(query) => onChange({ ...value, query })}
      searchPlaceholder={t("jobs.filter.searchPlaceholder")}
      clearSearchLabel={t("jobs.filter.clearSearch")}
      modes={[
        { id: "all", label: t("jobs.filter.all") },
        { id: "published", label: t("jobs.filter.published") },
        { id: "draft", label: t("jobs.filter.draft") },
      ]}
      mode={value.status}
      onModeChange={(status) => onChange({ ...value, status })}
      optionsLabel={t("jobs.filter.trigger")}
      options={[
        { id: "schedule", label: t("jobs.filter.schedule"), icon: CalendarClock },
        { id: "webhook", label: t("jobs.filter.webhook"), icon: Webhook },
      ]}
      selected={value.triggers}
      onToggleOption={(id) =>
        onChange({
          ...value,
          triggers: value.triggers.includes(id) ? value.triggers.filter((t) => t !== id) : [...value.triggers, id],
        })
      }
      clean={isEmptyJobsFilter(value)}
      onClear={() => onChange(EMPTY_JOBS_FILTER)}
      clearLabel={t("jobs.filter.clear")}
      total={total}
      noResultsLabel={t("jobs.filter.noResults")}
    />
  );
};
